import { Trans, useTranslation } from "react-i18next";

import { type PaymentRead, PaymentType } from "@/api-v3";

interface VisitSubmittedItemsProps {
  payments: PaymentRead[];
}

export const VisitSubmittedItems = ({ payments }: VisitSubmittedItemsProps) => {
  const { t } = useTranslation();

  const counts = payments.reduce(
    (acc, payment) => {
      if (
        payment.type === PaymentType.receipt_claim ||
        payment.type === PaymentType.mileage_claim
      ) {
        acc.claims += 1;
      } else if (payment.type === PaymentType.stipend) {
        acc.stipend = true;
      }
      return acc;
    },
    { claims: 0, stipend: false }
  );

  const flags: string[] = [];
  const values: Record<string, string> = {};
  if (counts.claims) {
    flags.push("claims");
    values.claims = t("visits_claimCount", { count: counts.claims });
  }
  if (counts.stipend) {
    flags.push("stipend");
    values.stipend = t("visits_stipend");
  }

  if (!flags.length) {
    return null;
  }

  return (
    <p className="text-sm text-muted-foreground">
      <Trans
        i18nKey={`visits_submitted_${flags.join("_")}`}
        values={values}
        components={{
          s: <span className="font-semibold text-foreground" />,
        }}
      />
    </p>
  );
};
